import React from "react"
import styled from "styled-components"
import { theme } from "@op-str/op-component-library"

export const HorizontalLine = styled.div`
  width: 100%;
  border-bottom: solid 1px ${theme.color.white1};
`
